import React from "react";
import BettingDashboardMix from "./BettingDashboardMix";

export default (props) => {
    return <div>
        <BettingDashboardMix {...props}/>
    </div>
}